import { render, staticRenderFns } from "./PopoverRegalendario.vue.html?vue&type=template&id=3bc09b97&"
import script from "./PopoverRegalendario.component.js?vue&type=script&lang=vueJs&"
export * from "./PopoverRegalendario.component.js?vue&type=script&lang=vueJs&"
import style0 from "./PopoverRegalendario.scss?vue&type=style&index=0&prod&lang=vueScss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports